/* eslint-disable import/no-webpack-loader-syntax */
import React, { Component } from 'react'
import mediumEditor from 'medium-editor'

import 'medium-editor/dist/css/medium-editor.min.css'
// import 'medium-editor/dist/css/themes/default.min.css'
import '@/styles/plugin/medium-rte.css'
import IconFormatBold from '!raw-loader!@/media/svg/format_bold.svg'
import IconFormatItalic from '!raw-loader!@/media/svg/format_italic.svg'
import IconFormatListBulleted from '!raw-loader!@/media/svg/format_list_bulleted.svg'
import IconFormatListNumbered from '!raw-loader!@/media/svg/format_list_numbered.svg'
import IconInsertLink from '!raw-loader!@/media/svg/insert_link.svg'

export default class MediumEditor extends Component {
  static defaultProps = {
    tag: 'div',
    value: '<p>Click to edit text!</p>',
    onChange: () => {},
    options: {
      spellcheck: false,
      disableDoubleReturn: true,
      disableExtraSpaces: false,
      toolbar: {
        // static: true,
        // sticky: true,
        // relativeContainer: null,
        // buttons: ['bold', 'italic', 'anchor', 'orderedlist', 'unorderedlist'],
        buttons: [
          { name: 'bold', contentDefault: IconFormatBold },
          { name: 'italic', contentDefault: IconFormatItalic },
          { name: 'anchor', contentDefault: IconInsertLink },
          { name: 'orderedlist', contentDefault: IconFormatListNumbered },
          { name: 'unorderedlist', contentDefault: IconFormatListBulleted },
        ],
      },
    },
  }
  content = this.props.value

  componentDidMount = () => {
    const { options } = this.props
    this.medium = new mediumEditor(this.editor, options)
    this.medium.setContent(this.content)
    this.medium.subscribe('editableInput', this.onChange)
    this.medium.subscribe('focus', this.onFocus)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.value.replace(/\n|\r/g, '') === this.content.replace(/\n|\r/g, '')) return false
    return true
  }

  componentDidUpdate = () => {
    this.medium.restoreSelection()
  }

  componentWillUnmount = () => {
    this.medium.destroy()
  }

  render() {
    const { tag: Tag, value, onChange, options, selectText, ...props } = this.props

    if (this.medium) {
      this.medium.saveSelection()

      if (this.props.flushEditorDOM) {
        this.medium.setContent(this.props.value)
      }
    }

    return (
      <Tag
        ref={element => {
          this.editor = element
        }}
        {...props}
      />
    )
  }

  onFocus = evt => {
    if (
      !this.props.selectText ||
      !(
        (this.content && this.content === this.props.selectText) ||
        this.editor.innerHTML === this.props.selectText
      )
    ) {
      return
    }
    console.log('selecting')
    setTimeout(() => {
      this.medium.selectAllContents()
    }, 1)
  }

  onChange = evt => {
    let content = this.editor.innerHTML
    // Hack that removes span with style which is applied from body tag by contenteditable + medium
    if (content.includes('"font-size: 1.6em; letter-spacing: 0.01em;"')) {
      content = content
        .replace(/ style="font-size: 1\.6em; letter-spacing: 0\.01em;"/g, '')
        .replace('\n', '')
        .replace('\r', '')
      // Save caret / selection with medium
      this.medium.saveSelection()
      this.editor.innerHTML = content
      // Restore selection
      this.medium.restoreSelection()
    }
    if (content !== this.content) {
      this.content = content
      this.props.onChange(content.replace(/\n|\r/g, ''))
    }
  }
}



// WEBPACK FOOTER //
// ./ui/RTE/Medium.js